// src/hooks/useOnlineStatus.ts
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

export const useOnlineStatus = () => {
  // Initialize state with the browser's current online status
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Handler to update state to true when online
    const handleOnline = () => setIsOnline(true);
    // Handler to update state to false when offline
    const handleOffline = () => setIsOnline(false);

    // Add event listeners for online and offline events
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Cleanup function to remove event listeners when the component unmounts
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    // Log the online status whenever it changes
    console.log(`Online status changed: ${isOnline ? "Online" : "Offline"}`);
  }, [isOnline]);

  return isOnline;
};
